"use client";

import { useRef } from "react";
import { Provider } from "react-redux";
import { makeStore, AppStore } from "@/lib/features/store";
import NotificationBell from "@/components/Notification/NotificationBell";
import FirebaseNotificationSubscriber from "@/components/PushNotificationSubscriber/FirebaseNotification";
import PushPermissionSubscriber from "@/components/PushNotificationSubscriber/PushPermissionSubscriber";

export default function NotificationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const storeRef = useRef<AppStore>();
  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return (
    <Provider store={storeRef.current}>
      <NotificationBell />
      <FirebaseNotificationSubscriber />
      <PushPermissionSubscriber />
      {children}
    </Provider>
  );
}
